import * as React from 'react';
import FontNamePicker from '../FontNamePicker';
import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { setFontName } from 'roosterjs-editor-api';

const fontName: RibbonButton = {
    key: 'fontName',
    title: () => strings.fontName,
    imageSrc: require('../svg/fontname.svg'),
    createDropDownCallback: (target, plugin, dismiss, logUsage) => (
        <FontNamePicker
            menuTargetElement={target}
            onDismissMenu={dismiss}
            onSelectName={font => {
                setFontName(plugin.getEditor(), font.family);
                logUsage('setFontName', font.family);
            }}
            selectedName={plugin.getFormatState().fontName}
        />
    ),
};

export default fontName;
